// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".round[data-v-9b926bd6] {\n  border-radius: 50%;\n  border: 1px solid var(--v-textColor-base);\n}\n.wallet-creation[data-v-9b926bd6] {\n  min-width: 185px;\n}\n.full-width-btn[data-v-9b926bd6] {\n  width: 100%;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
